import AppIcon from "@/components/AppIcon.vue";
import PpcSPProductAdItem from "@/components/PpcSPProductAdItem.vue";
import AppInput from "@/components/AppInput";
import PauseIcon from "@/components/icons/PauseIcon.vue";
import PlayIcon from "@/components/icons/PlayIcon.vue";
export default {
  name: "PpcSPProductAds",
  emits: ["close"],
  components: {
    AppIcon,
    PpcSPProductAdItem,
    AppInput,
    PauseIcon,
    PlayIcon
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected_profile_id: {
      type: String
    },
    country_code: {
      type: String
    },
    group_by_type: String
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    localSearch: {
      get() {
        return this.search;
      },
      set(value) {
        this.search = value;
      }
    },
    filteredItems() {
      const stateValueMap = {
        "ENABLED": 1,
        "PAUSED": 0,
        "MIXED": -1
      };
      return this.items?.filter(this.itemsFilter)?.sort((a, b) => {
        const aHasName = !!a.asin_name?.trim();
        const bHasName = !!b.asin_name?.trim();
        if (aHasName !== bHasName) {
          return aHasName ? -1 : 1;
        }
        if (a.asin !== b.asin) {
          return a.asin.localeCompare(b.asin);
        }
        return stateValueMap[b.aggregated_state] - stateValueMap[a.aggregated_state];
      });
    },
    pausedCount() {
      return this.filteredItems?.filter(product_ad => product_ad?.aggregated_state !== 'ENABLED')?.length;
    },
    enabledCount() {
      return this.filteredItems?.filter(product_ad => product_ad?.aggregated_state === 'ENABLED')?.length;
    }
  },
  methods: {
    itemsFilter(item) {
      const search = this.search.toLowerCase();
      return item?.name?.toLowerCase()?.includes(search) || item?.sku?.toLowerCase()?.includes(search) || item?.asin?.toLowerCase()?.includes(search);
    }
  }
};